import locale from 'locale-codes';

const allLanguages = locale.all
  .filter((locale) => locale.location)
  .map((locale) => ({ value: locale.tag.replace('-', '_'), label: `${locale.name} (${locale.location})` }));

export default allLanguages;
